import { render } from "./EgyProjects.vue?vue&type=template&id=55303174"
import script from "./EgyProjects.vue?vue&type=script&lang=js"
export * from "./EgyProjects.vue?vue&type=script&lang=js"
script.render = render

export default script